
import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'SlideInOut' })
export default class extends Vue {
  slideIn(el: HTMLElement) {
    this.animateHeight(el, '0', this.currentHeight(el))
  }

  slideOut(el: HTMLElement) {
    this.animateHeight(el, this.currentHeight(el), '0')
  }

  clearHeight(el: HTMLElement) {
    el.style.height = 'auto'
  }

  currentHeight(el: HTMLElement): CSSStyleDeclaration['height'] {
    return getComputedStyle(el).height
  }

  animateHeight(el: HTMLElement, start: CSSStyleDeclaration['height'], end: CSSStyleDeclaration['height']) {
    el.style.height = start
    window.requestAnimationFrame(() => (el.style.height = end))
  }
}
